import * as React from 'react';
import { TableCell } from '../TableCell';
import * as styles from './TableHeader.css';

interface IProps {
  contentColTitle: string;
}

export const TableHeader = (props: IProps) => {
  const { contentColTitle } = props;

  return (
    <div className={styles['header']}>
      <TableCell header>{contentColTitle}</TableCell>

      <TableCell header>Стоимость</TableCell>
    </div>
  );
};
